import React, { useEffect, useState } from "react";
import "./App.css";
import { LangPageProps } from "./interfaces/ComponentProps";
import { Trans, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { Spinner } from "@fluentui/react";
import { SiteHelper } from "./helpers/SiteHelper";
import { ErrorMessage } from "./ErrorMessage";

export const DeleteMFADevicesPage = ({ lang }: LangPageProps) => {
  const { t } = useTranslation(['deleteMFADevices']);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const DeleteFMADevices = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      if (token === null || token === undefined) {
        setMessage(t("noTokenMessage"));
        setIsSuccess(false);
        return;
      }

      var status = await SiteHelper.DeleteMFADevices(
        token
      )

      //console.log(status);
      //console.log(status.message);

      if (status.success) {
        setMessage(t("successMessage"));
        setIsSuccess(true);
      } else {
        if(status.message.includes("00|")) {
          setMessage(t("00| Generic error while executing the request"));
        }else{
          setMessage(status.message);
        }
        setIsSuccess(false);
      }
    }

    DeleteFMADevices().then(() => {
      setLoading(false);
    });
  }, [])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    i18n.changeLanguage(lang);
  }, [lang])

  return (
    <div className="Container-Main">
      <a href={`${window.location.origin}`}>
        <div style={{ cursor: 'pointer' }} onClick={() => window.location.replace(`${window.location.origin}`)}>
          <img src={`${process.env.REACT_APP_SiteUrl}/media/images/CNH_Header.png`} className="App-logo" alt="logo" />
        </div>
      </a>
      <div className="App">
        <div className="App-header">
          <div className="App_bodyDeleteMFA">
            {loading ? <Spinner label={t("loading")} style={{ color:"red" }} color="red" /> :
              <>
                {console.log(isSuccess)}
                {console.log(message)}
                {isSuccess ?
                  <p className="submitted"><strong>
                    <Trans t={t} i18nKey="successMessage" components={{ em: <em />, p: <p />, strong: <strong /> }} />
                  </strong></p> :
                  //t("successMessage") :
                  <ErrorMessage errorMessage={message} />
                }
              </>
            }
          </div></div>
      </div>
      <footer>
        <img src={`${process.env.REACT_APP_SiteUrl}/media/images/CNH_Footer.png`} className="App-footer" alt="logo" />
      </footer>
    </div>
  );
}
